<template>
  <div class="deposit-amount-picker">
    <div
      class="deposit-amount-picker__field-wrapper"
      :class="{
        'deposit-amount-picker__field-wrapper--has-value': !!modelValue,
        'deposit-amount-picker__field-wrapper--disabled': disabled,
      }"
      @click="$refs.input.focus()"
    >
      <span class="deposit-amount-picker__currency">$</span>
      <div class="deposit-amount-picker__input-sizer">
        <span class="deposit-amount-picker__input-mirror" aria-hidden="true">{{
          formattedValue || '0.00'
        }}</span>
        <input
          ref="input"
          class="deposit-amount-picker__input"
          type="text"
          :value="formattedValue"
          @input="handleInput"
          @blur="$emit('blur')"
          :disabled="disabled"
          placeholder="0.00"
          size="1"
          :autofocus="!isWrapperApp"
        />
      </div>
    </div>
    <div v-if="hasError" class="deposit-amount-picker__error">
      {{ errorMessage }}
    </div>
    <div class="deposit-amount-picker__chips">
      <button
        v-for="amount in depositAmounts"
        :key="amount"
        type="button"
        class="deposit-amount-picker__chip"
        @mousedown.prevent
        @click.prevent.stop="$emit('add', amount)"
        :disabled="disabled"
      >
        <span class="deposit-amount-picker__chip-icon"> </span> ${{ amount }}
      </button>
    </div>
  </div>
</template>

<script src="./deposit-amount-picker.js"></script>
<style src="./deposit-amount-picker.scss" lang="scss"></style>
